<template>
  <v-dialog v-model="editCompDialog" scrollable max-width="600px">
    <v-card>
      <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor.hex }">
        <h2 style="color:white">Bedrijf bewerken</h2>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeEditCompDialog()">
          <v-icon dark color="white">close</v-icon>
        </v-btn>
      </v-card-title>

      <div class="hogans-alerts">
        <v-alert
          v-if="feedback"
          :value="true"
          type="warning"
        >
        {{ feedback }}
        </v-alert>
      </div>

      <v-divider></v-divider>

      <v-card-text>
        <v-form  ref="editCompForm" v-model="valid" lazy-validation>
          <v-text-field
            class="pt-4"
            label="Bedrijfsnaam"
            v-model="selectedCompany.name"
            prepend-inner-icon="account_box"
            :rules="requiredRules"
            :color="companyPrimaryColor.hex"
            :background-color="$vuetify.theme.themes[theme].menu"       
            hide-details
            required
            outlined
          ></v-text-field>
          <v-text-field
            class="pt-4"
            label="Email"
            v-model="selectedCompany.email"
            :rules="emailRules"
            prepend-inner-icon="email"
            :color="companyPrimaryColor.hex"
            :background-color="$vuetify.theme.themes[theme].menu"       
            hide-details
            required
            outlined
          ></v-text-field>
          <v-text-field
            class="pt-4"
            label="Url"
            v-model="selectedCompany.url"
            prepend-inner-icon="web"
            :rules="requiredRules"
            :color="companyPrimaryColor.hex"
            :background-color="$vuetify.theme.themes[theme].menu"       
            hide-details
            required
            outlined
          ></v-text-field>
          <v-select
            class="pt-4"
            v-model="selectedCompany.languages"
            :items="languages"
            multiple
            label="Selecteer talen"
            item-text="name"
            item-value="code"
            prepend-inner-icon="flag"
            :rules="requiredRules"
            :item-color="companyPrimaryColor.hex"
            :color="companyPrimaryColor.hex"
            :background-color="$vuetify.theme.themes[theme].menu"       
            hide-details
            required
            outlined
          ></v-select>
          <v-select
            class="pt-4"
            v-model="selectedCompany.packages"
            :items="packages"
            multiple
            label="Selecteer pakketten"
            item-text="name"
            item-value="id"
            chips
            prepend-inner-icon="lock"
            :rules="requiredRules"
            :item-color="companyPrimaryColor.hex"
            :color="companyPrimaryColor.hex"
            :background-color="$vuetify.theme.themes[theme].menu"       
            hide-details
            required
            outlined
          ></v-select>
          
          <div class="pa-3 my-4" :style="{backgroundColor: $vuetify.theme.themes[theme].menuborder}">
            <v-alert
              v-if="doublePackages.active"
              dense
              border="left"
              type="warning"
              >
              Er <span v-if="doublePackages.packages.length == 1">is</span> <span v-else>zijn</span> {{ doublePackages.packages.length }} pakket<span v-if="doublePackages.packages.length > 1">ten</span> aangeschaft en als trial ingesteld:
              <div v-for="(doublePackage, index) in doublePackages.packages" :key="index">
                <span v-for="(originalPackage, index) in packages" :key="index">
                  <span v-if="doublePackage == originalPackage.id"><strong> &#x2022; {{originalPackage.name}}</strong></span>
                </span>
              </div>
            </v-alert>
            <h2>Pakketten om te proberen</h2>
            <v-select
              class="pt-4"
              v-model="selectedCompany.trials"
              :items="filteredPackages"
              multiple
              label="Trial pakketten"
              item-text="name"
              item-value="id"
              chips
              prepend-inner-icon="timelapse"
              :item-color="companyPrimaryColor.hex"
              :color="companyPrimaryColor.hex"
              :background-color="$vuetify.theme.themes[theme].menu"       
              hide-details
              return-object
              required
              outlined
            ></v-select>

            <div>
              <div v-for="(trailPackage, index) in selectedCompany.trials" :key="index" class="py-1">
                <h3 class="py-2"><strong>{{ trailPackage.name }}</strong></h3>

                <v-container grid-list-md class="pa-0" fluid>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-menu
                        :close-on-content-click="false"
                        v-model="datePickerDialog[trailPackage.name]"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            outlined
                            style="max-width: 450px"
                            :color="companyPrimaryColor.hex"
                            v-on="on"
                            dense
                            :background-color="$vuetify.theme.themes[theme].menu"
                            v-model="trailPackage.trialStartDate"
                            label="Startdatum"
                            prepend-inner-icon="event"
                            readonly
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="trailPackage.trialStartDate"
                          :color="companyPrimaryColor.hex"
                          no-title
                          @input="datePickerDialog[trailPackage.name] = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex md5>
                      <v-text-field
                        outlined
                        style="max-width: 450px"
                        :color="companyPrimaryColor.hex"
                        dense
                        :background-color="$vuetify.theme.themes[theme].menu"
                        v-model.number="trailPackage.trialDays"
                        label="Aantal dagen"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex md1>
                      <v-btn style="margin: 2px 0" icon :color="companyPrimaryColor.hex">
                        <v-icon @click="selectedCompany.trials.splice(index, 1)">close</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </div>
          </div>

          <v-select
            class="pt-4"
            v-model="selectedCompany.type"
            :items="companyTypes"
            label="Type bedrijf"
            item-text="name"
            item-value="id"
            prepend-inner-icon="business_center"
            :rules="requiredRules"
            :item-color="companyPrimaryColor.hex"
            :color="companyPrimaryColor.hex"
            :background-color="$vuetify.theme.themes[theme].menu"       
            hide-details
            required
            outlined
          ></v-select>
          <div class="color-box-wrapper clear pt-4">
            <div class="color-boxes-icon">
              <v-icon>palette</v-icon>
            </div>
            <div class="color-boxes clear">
              <p class="ma-0">Selecteer primaire en secondaire kleur</p>
              <div class="color-box" v-bind:style="{ backgroundColor: companyPrimaryColor.hex }" @click="primaryColorDialog = true"></div>
              <div class="color-box" v-bind:style="{ backgroundColor: companySecondaryColor.hex}" @click="secondaryColorDialog = true"></div>
            </div>
          </div>

          <div class="upload-image-wrapper clear pt-4">
            <div class="upload-image-icon">
              <v-icon>image</v-icon>
            </div>
            <div class="upload-image">
              <p class="ma-0">Upload bedrijfslogo</p>
              <div class="logo-upload-preview">
                <img v-show="isLoaded == true" :src="selectedCompany.logoUrl" @load="loaded">
                <div v-show="isLoaded == false" class="image-spinner"></div>
                <div v-if="uploading == true" class="upload-bar">
                  <p class="ma-0">{{ uploadProgress }} %</p>
                  <div class="upload-bar-inner" v-bind:style="{ backgroundColor: companyPrimaryColor.hex , width: uploadProgress  + '%'  }"></div>
                </div>
              </div>
              <v-btn raised :color="companyPrimaryColor.hex" dark @click="onFileSelect">Kies afbeelding</v-btn>
              <input
                type="file"
                style="display: none;"
                ref="fileInput"
                accept="image/*"
                @change="onFilePicked">
            </div>
          </div>

          <div class="form-active-switch">
            <v-switch
              :color="companyPrimaryColor.hex"
              label="Actief"
              v-model="selectedCompany.active"
            ></v-switch>
          </div>

        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
              <v-btn
                outlined
                depressed
                color="#8B93A6"
                @click="closeEditCompDialog()"
                >
                Annuleren
              </v-btn>
            </v-flex>
            <v-flex xs12 md6 class="text-right">
              <v-btn
                :depressed="!changed"
                :disabled="!changed"
                :dark="changed"
                rounded
                :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                :color="companySecondaryColor.hex"
                @click="updateCompany()"
                >
                Wijzigingen opslaan
                <v-icon right dark>chevron_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>



      <v-dialog width="225px" v-model="primaryColorDialog">
        <chrome-picker v-model="selectedCompany.colors.primary"></chrome-picker>
      </v-dialog>

      <v-dialog width="225px" v-model="secondaryColorDialog">
        <chrome-picker v-model="selectedCompany.colors.secondary"></chrome-picker>
      </v-dialog>

    </v-card>
  </v-dialog>
</template>


<script>
import { Chrome } from "vue-color";
import db from "../../firebase/init";
import firebase from "firebase/app";
import _ from "lodash";
import platform from 'platform'; 
import moment from 'moment';

export default {
  name: "edit-comp-form",
  components: {
    "chrome-picker": Chrome
  },
  props: {
    editCompDialog: Boolean,
    selectedCompany: Object,
    selectedCompanyOriginal: Object
  },

  data() {
    return {
      isLoaded: false,
      valid: true,
      filename: null,
      image: null,
      datePickerDialog: {},
      primaryColorDialog: false,
      secondaryColorDialog: false,
      selectedLanguages: ["nl"],
      companyTypes: [
        {
          name: "Kapper",
          id: "hairsalon"
        },
        {
          name: "Anders",
          id: "other"
        }
      ],
      packages: [
        {
          name: "Reviews",
          id: "customerjourney",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Afspraakwidget",
          id: "conversion",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        }, 
        {
          name: "Call Center",
          id: "callcenter",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Barometers",
          id: "barometers",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Dossier",
          id: "dossier",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Dossier Foto's",
          id: "dossierphotos",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Narrowcasting",
          id: "narrowcasting",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Adwords",
          id: "adwords",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Nieuwsbrieven",
          id: "newsletters",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Website",
          id: "website",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "SMS",
          id: "sms",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        }
      ],
      languages: [
        {
          code: "nl",
          name: "Nederlands"
        },
        {
          code: "en",
          name: "Engels"
        }
      ],
      emailRules: [
        v => !!v || "E-mail is verplicht",
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
      ],
      requiredRules: [v => !!v || "Dit veld is verplicht"],
      feedback: null,
      recordId: null,
      uploading: false,
      uploadProgress: null,
      file: {}
    };
  },

  created(){
    console.log("Company edit is created")
  },

  methods: {
    loaded() {
      this.isLoaded = true;
    },

    onFileSelect() {
      this.$refs.fileInput.click();
    },

    onFilePicked(event) {
      const files = event.target.files;
      this.file = files[0];
      let filename = files[0].name;
      this.filename = filename;
      console.log("files: " + filename);
      if (filename.lastIndexOf(".") <= 0) {
        this.feedback = "Voeg een geldig bestand toe.";
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.selectedCompany.logoUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
      this.feedback = null;
    },

    closeEditCompDialog() {
      this.$emit("editCompDialogChange", false);
      this.isLoaded = false;
      this.feedback = null;
    },

    uploadCompanyLogo() {
      return new Promise((resolve, reject) => {
        console.log("start storen");
        const file = this.file;
        const filename = this.filename;
        const ext = filename.slice(filename.lastIndexOf("."));
        const fileUrl = this.selectedCompany.id + "/" + "logo/" + this.selectedCompany.id + "-logo" + ext;
        this.uploading = true;
        let uploadTask = firebase
          .storage()
          .ref(fileUrl)
          .put(file);

        uploadTask.on(
          "state_changed",
          taskSnapshot => {
            var progress = Math.ceil((taskSnapshot.bytesTransferred / taskSnapshot.totalBytes) * 100);
            this.uploadProgress = progress;
          },
          error => {
            console.log(error);
            reject();
          },
          () => {
            console.log("The upload is compleet");
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(url => {
                db.collection("companies")
                  .doc(this.selectedCompany.id)
                  .update({
                    logoUrl: url
                  })
                  .then(() => {
                    resolve();
                    this.uploading = false;
                    this.uploadProgress = null;
                    this.filename = null;
                  })
                  .catch(error => {
                    reject();
                    this.uploading = false;
                    this.uploadProgress = null;
                    this.filename = null;
                  });
              })
              .catch(error => {
                reject();
                this.filename = null;
                this.uploading = false;
                this.uploadProgress = null;
              });
          }
        );
      });
    },

    updateCompany() {
      if (this.$refs.editCompForm.validate()) {
        let companyColors = {};
        companyColors.primary = this.companyPrimaryColor;
        companyColors.secondary = this.companySecondaryColor;
        db.collection("companies")
          .doc(this.selectedCompany.id)
          .set({
            active: this.selectedCompany.active,
            name: this.selectedCompany.name,
            email: this.selectedCompany.email,
            url: this.selectedCompany.url,
            type: this.selectedCompany.type,
            packages: this.selectedCompany.packages,
            trials: this.selectedCompany.trials,
            languages: this.selectedCompany.languages,
            colors: this.selectedCompany.colors
          },{merge: true})
          .then(async () => {
            if (this.filename) {
              await this.uploadCompanyLogo();
            }
          })

          .then(() => {
            // Log Action
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + " " + platform.version, 
              pillarrrVersion: this.$store.state.version,
              action: "Bedrijf bewerkt: " + this.selectedCompany.name,
              extra:
                "<b>ORIGINELE GEGEVENS</b>" +
                "<br>" +
                "<b>Active</b>: " +
                this.selectedCompanyOriginal.active +
                "<br>" +
                "<b>Naam</b>: " +
                this.selectedCompanyOriginal.name +
                "<br>" +
                "<b>E-mail</b>: " +
                this.selectedCompanyOriginal.email +
                "<br>" +
                "<b>Primaire kleur</b>: " +
                this.selectedCompanyOriginal.colors.primary.hex +
                "<br>" +
                "<b>Secondaire kleur</b>: " +
                this.selectedCompanyOriginal.colors.secondary.hex +
                "<br>" +
                "<b>Url</b>: " +
                this.selectedCompanyOriginal.url +
                "<br><br>" +
                "<b>AANGEPAST GEGEVENS</b>" +
                "<br>" +
                "<b>Active</b>: " +
                this.selectedCompany.active +
                "<br>" +
                "<b>Naam</b>: " +
                this.selectedCompany.name +
                "<br>" +
                "<b>E-mail</b>: " +
                this.selectedCompany.email +
                "<br>" +
                "<b>Primaire kleur</b>: " +
                this.companyPrimaryColor.hex +
                "<br>" +
                "<b>Secondaire kleur</b>: " +
                this.companySecondaryColor.hex +
                "<br>" +
                "<b>Url</b>: " +
                this.selectedCompany.url
            });
          })
          .then(() => {
            this.closeEditCompDialog();
            this.$emit("updateData");
            this.isLoaded = false;
            this.feedback = null;
          })
          .catch(error => {
            console.error("Error updating Company: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error updating Company: " + this.activeCompName,
              software: String(platform.os),
              browser: platform.name + " " + platform.version, 
              pillarrrVersion: this.$store.state.version,
              extra: JSON.stringify(error)
            });
          });
      } else {
        this.feedback = "Vul de vereiste gegevens in om op te slaan.";
      }
    }
  },
  computed: {
    filteredPackages() {
      let packagesForTrial = []
      this.packages.forEach(availablePackage => {
        if((_.indexOf(this.selectedCompany.packages, availablePackage.id) == -1) || (_.findIndex(this.selectedCompany.trials, {'id': availablePackage.id}) >= 0)){
          packagesForTrial.push(availablePackage)
        }
      })
      return packagesForTrial;
    },

    doublePackages() {
      let doublePackages = {
        active: false,
        packages: []
      }
      if(this.selectedCompany.packages && this.selectedCompany.packages.length > 0){
        this.selectedCompany.packages.forEach(selectedPackage => {
          this.selectedCompany.trials.forEach(trialPackage => {
            if(selectedPackage == trialPackage.id){
              doublePackages.active = true;
              doublePackages.packages.push(selectedPackage);
            }
          })
        })
        if(doublePackages.length > 0){
          return doublePackages;
        }
        else{
          return doublePackages;
        }
      }
      else{
        return doublePackages;
      }
    },

    companyPrimaryColor() {
      return this.selectedCompany.colors.primary;
    },
    companySecondaryColor() {
      return this.selectedCompany.colors.secondary;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    changed() {
      if (_.isEqual(this.selectedCompany, this.selectedCompanyOriginal) == false) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style>
.upload-image-wrapper {
  padding: 20px 0 0 0;
}

.upload-image-icon {
  float: left;
  width: 35px;
  padding: 20px 0 0 0;
}

.upload-image {
  float: left;
}

.upload-image-wrapper p {
  font-family: "Sofia Pro", sans-serif;
  color: rgba(0, 0, 0, 0.54);
  font-weight: 400;
  padding: 0 0 5px 0;
  font-size: 12px;
  margin: 0;
}

.logo-upload-preview {
  position: relative;
  width: 150px;
  height: 150px;
  float: left;
  margin: 0 15px 0 0;
  overflow: hidden;
  background-color: #f6f7fb;
}

.logo-upload-preview img {
  width: 100%;
  height: auto;
}

.color-boxes-icon {
  float: left;
  width: 35px;
  padding: 20px 0 0 0;
}

.color-boxes {
  float: left;
}
.color-box-wrapper p {
  font-family: "Sofia Pro", sans-serif;
  color: rgba(0, 0, 0, 0.54);
  font-weight: 400;
  padding: 0 0 5px 0;
  font-size: 12px;
  margin: 0;
}

.color-box {
  float: left;
  margin: 0 15px 0 0;
  width: 40px;
  height: 25px;
  border: 1px solid rgba(0, 0, 0, 0.3);
}

.color-box:hover {
  cursor: pointer;
}

.upload-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20px;
  background-color: rgba(150, 150, 150, 0.8);
}

.upload-bar p {
  z-index: 99;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  line-height: 20px;
  width: 100%;
  height: 20px;
  color: #fff;
  font-weight: 600;
}

.upload-bar-inner {
  z-index: 9;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 20px;
}
</style>
